var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCornerDecor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 677.765,
    height: 422.461,
    viewBox: "0 0 677.765 422.461",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.87,
    y1: 0.873,
    x2: 0.129,
    y2: 0.196,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#453878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#9987ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.724,
    y1: 0.267,
    x2: -0.14,
    y2: -0.422,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f04e98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441,
    stopColor: "#f66957"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8f00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.927,
    y1: 0.57,
    x2: -0.053,
    y2: -0.069,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1.057,
    y1: 0.732,
    x2: 0.007,
    y2: 0.115,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1.329,
    y1: 0.797,
    x2: 0.121,
    y2: 0.213,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 3.725,
    y1: 0.793,
    x2: 2.999,
    y2: 0.087,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.192,
    y1: 0.662,
    x2: -0.421,
    y2: -0.237,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00cdc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6154c7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.88,
    y1: 0.826,
    x2: 0.082,
    y2: 0.116,
    xlinkHref: "#linear-gradient-7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_476",
    "data-name": "Group 476",
    transform: "translate(-1376.536 -4354.397)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M1416.737,4903.487c-52.293-15.649-104,20.229-113.635,72.763-2.276,4.416-38.283,36.145-34.225,42.041.921,6.4,14.827,7.239,19.229,9.283-11.641,42.812-24.567,52.733,29.756,56.253-.365,4.448-11.093,29.374-6.988,33.248-4.566,4.445,93.853,13.027,94.541,13.948a7.383,7.383,0,0,0,7.974-5.262l12.768-43.707c2.885-9.873,10.049-16.372,15.558-20.1C1503,5022.756,1487.517,4921.923,1416.737,4903.487Zm12.839,89.435c-8.2,2.882-59.7,44.6-68.761,37.583-6.217-1.216-17.722-24.475-21.447-28.876-9.166-13.947,12.868-28.068,21.7-13.915l8.415,13.115,46.144-29.619C1429.616,4962,1443.721,4984.084,1429.576,4992.922Z",
    transform: "translate(107.978 -409.042)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M1425.489,5175.859c-13.708,2.85-43.985,21.5-50.871-.684l-20.047-62.459a16.2,16.2,0,0,1,10.473-20.371l30.5-9.789a16.2,16.2,0,0,1,20.372,10.472l20.046,62.459A16.2,16.2,0,0,1,1425.489,5175.859Z",
    transform: "translate(107.978 -409.042)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M1500.111,5152.234c-13.717,2.837-43.972,21.518-50.872-.684l-34.76-108.3c-7.33-22,28.2-24.549,40.974-30.161a16.2,16.2,0,0,1,20.371,10.473l34.759,108.3A16.2,16.2,0,0,1,1500.111,5152.234Z",
    transform: "translate(107.978 -409.042)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M1575.286,5128.107c-13.724,2.826-43.962,21.53-50.872-.684l-46.479-144.817c-7.331-21.994,28.2-24.549,40.973-30.161a16.2,16.2,0,0,1,20.372,10.473l46.478,144.817A16.2,16.2,0,0,1,1575.286,5128.107Z",
    transform: "translate(107.978 -409.042)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M1561.367,4763.516c-9.49,1.946-1.422,17.552-2.955,21.682-.6,2.032-4.545,9.184-8.8,16.389l-20.421,6.554c-15.9-7.131-17.612-6.545-23.541-20.927-3.111-7.427-14.669-2.364-11.372,4.954.9,2.083,5.611,12.626,9.484,16.572,2.786,2.806,14.378,8.184,24.553,12.551l16.331,50.956a20.521,20.521,0,0,0-9.668,24.255l64.886,202.173c8.032,22.968,32.026,11.36,48.084,6.115a20.513,20.513,0,0,0,13.266-25.805l-64.886-202.173a20.5,20.5,0,0,0-23.283-13.889l-15.96-49.655c5.939-9.772,12.9-21.872,13.555-25.992C1570.425,4778.341,1571.433,4762.2,1561.367,4763.516Zm-10.722,84.631,3.565-1.145,4.131,12.87a8.4,8.4,0,0,0-3.491,1.376Z",
    transform: "translate(107.978 -409.042)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M1537.631,4802.249c18.071-5.525,9.008-33.767-8.905-27.74C1510.66,4780.032,1519.724,4808.274,1537.631,4802.249Z",
    transform: "translate(107.978 -409.042)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M1850.821,4835.793l-80.1-27.4c-4.051-1.386-6.307-5.516-5.038-9.224l10.42-30.459c1.269-3.708,5.582-5.59,9.633-4.2l80.1,27.4c4.052,1.386,6.307,5.516,5.039,9.224l-10.421,30.458C1859.185,4835.3,1854.873,4837.179,1850.821,4835.793Z",
    transform: "translate(107.978 -409.042)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M1932.494,4842.5l-58.393-19.978c-3.788,9.307-5.914,30.127-22.584,24.015l-87.864-30.06c-16.837-5.33-5.948-23.21-3.139-32.816l-53.543-18.319c-10.159-3.475-20.778.674-23.718,9.268l-103.4,302.236c-2.941,8.594,2.911,18.379,13.07,21.855l225.523,77.157c10.159,3.476,20.777-.674,23.718-9.268l103.4-302.236C1948.5,4855.762,1942.653,4845.978,1932.494,4842.5Zm-218.548,181.386c-5.036,1.386-41.2,24.779-46.6,20.945-5.058-.97-12.166-16.267-15-19.637-6.064-9.269,9.139-17.192,14.976-7.808l5.564,8.707,31.84-16.623C1714.379,5004.286,1723.7,5018.944,1713.946,5023.888Zm21.411-62.581c-5.036,1.386-41.2,24.779-46.6,20.945-5.058-.97-12.167-16.267-15-19.637-6.065-9.269,9.138-17.192,14.976-7.808l5.564,8.707,31.839-16.623C1735.789,4941.705,1745.113,4956.363,1735.357,4961.307Zm21.411-62.581c-5.036,1.386-41.2,24.779-46.6,20.945-5.059-.97-12.167-16.267-15-19.637-6.064-9.269,9.139-17.192,14.977-7.808l5.564,8.707,31.839-16.623C1757.2,4879.124,1766.524,4893.782,1756.768,4898.726ZM1815,5077.406l-74.516-25.494c-4.089-1.4-6.387-5.606-5.106-9.348s5.673-5.66,9.762-4.261l74.516,25.494C1829.311,5066.976,1824.617,5080.822,1815,5077.406Zm21.411-62.581-74.516-25.494c-4.089-1.4-6.387-5.606-5.107-9.348s5.674-5.66,9.763-4.261l74.516,25.494C1850.722,5004.4,1846.027,5018.241,1836.411,5014.825Zm21.41-62.581-74.515-25.494c-4.089-1.4-6.387-5.606-5.107-9.348s5.674-5.659,9.762-4.261l74.516,25.494C1872.133,4941.814,1867.438,4955.66,1857.821,4952.244Z",
    transform: "translate(107.978 -409.042)",
    fill: "url(#linear-gradient-8)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCornerDecor);
export default __webpack_public_path__ + "static/media/corner-decor.365469f4236453e0ac881061210ace8c.svg";
export { ForwardRef as ReactComponent };